import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './PromoutedCard.css';

class PromoutedCard extends React.Component {
  static propTypes = {
    fullPrice: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    year: PropTypes.number.isRequired,
    make: PropTypes.shape().isRequired,
    maker: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
    model: PropTypes.shape().isRequired,
    mileageText: PropTypes.string,
    engineTitle: PropTypes.string,
    gearboxTitle: PropTypes.string,
    shouldEmphasizePrice: PropTypes.bool,
    isNegotiablePrice: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    fullPrice: null,
    mileageText: null,
    engineTitle: '',
    gearboxTitle: '',
    abroadTitle: '',
    drivenFromTitle: '',
    shouldEmphasizePrice: false,
    isNegotiablePrice: false,
  };

  render() {
    const {
      fullPrice,
      year,
      mileageText,
      engineTitle,
      gearboxTitle,
      make,
      maker,
      model,
      shouldEmphasizePrice,
      isNegotiablePrice,
      intl,
    } = this.props;

    return (
      <div className={s.root}>
        <div>
          <div className={s.title}>
            {(maker && maker.title) || (make && make.title)} {model && model.title}
          </div>
          <div className={s.info}>
            {year &&
              <span>
                {year}
              </span>}
            {mileageText &&
              <span>
                {mileageText}
              </span>}
          </div>
          <div className={s.info}>
            {engineTitle &&
              <span>
                {engineTitle || ''}
              </span>}
            {gearboxTitle &&
              <span>
                {gearboxTitle || ''}
              </span>}
          </div>
        </div>
        {fullPrice &&
          !isNegotiablePrice &&
          <div className={cx(s.price, { [s.emphasizePrice]: shouldEmphasizePrice })}>
            {fullPrice}
          </div>}

        {isNegotiablePrice &&
          <div className={cx(s.price)}>
            {intl.formatMessage({ id: 'договорная' })}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(PromoutedCard);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertCard/PromoutedCard/PromoutedCard.js